import React, { memo } from 'react';
import {
	preFillableFormsTableColumns,
	usePreFillableFormsTableController,
} from '@dealstack/frontend/admin/pages/Manage/ManagePreFillableForms/PreFillableFormsTable/usePreFillableFormsTableController.tsx';
import { Button, Divider, Flex, Text } from '@mantine/core';
import { GODMODE_ROOT_ROUTES } from '@dealstack/frontend/admin/pages/Routing/Routing.tsx';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { MANAGE_PRE_FILLABLE_FORMS_ROUTES } from '@dealstack/frontend/admin/pages/Manage/ManagePreFillableForms/ManagePreFillableForms.tsx';
import { useNavigate } from 'react-router-dom';
import { DataPreFillableFormTemplateWithProjectsTct } from '@dealstack/shared/lib/generated';
import { MantineTable } from '@dealstack/frontend/shared/components/Table/MantineTable/MantineTable';

const PreFillableFormsTable = () => {
	const navigate = useNavigate();

	const { tableData, isLoading, mantineTableDataOperations } =
		usePreFillableFormsTableController();

	return (
		<div>
			<div style={{ maxHeight: pageHeaderHeight, overflow: 'hidden' }}>
				<Button
					size="sm"
					variant="outline"
					onClick={() => navigate(GODMODE_ROOT_ROUTES.DASHBOARD)}
					leftSection={<Icon variant="arrow-left" />}
				>
					Back to dashboard
				</Button>

				<Flex gap="2rem" align="center" justify="space-between" mt="1rem">
					<Text size="B4Bold">Manage pre-fillable form templates</Text>
					<Button
						size="md"
						variant="primary"
						onClick={() =>
							navigate(
								`${GODMODE_ROOT_ROUTES.MANAGE_PRE_FILLABLE_FORMS}/${MANAGE_PRE_FILLABLE_FORMS_ROUTES.CREATE}`
							)
						}
					>
						Add new form template
					</Button>
				</Flex>

				<Divider mt="1rem" mb="1rem" />
			</div>
			<MantineTable<DataPreFillableFormTemplateWithProjectsTct>
				key={JSON.stringify({ tableData })}
				isLoading={isLoading}
				data={tableData}
				columns={preFillableFormsTableColumns}
				rowCount={tableData.length}
				dataOperations={mantineTableDataOperations}
				manualPagination={false}
				manualFiltering={false}
				manualSorting={false}
				enableRowSelection={false}
				renderBulkActionsMenu={false}
			/>
		</div>
	);
};

const pageHeaderHeight = '20rem';
const _PreFillableFormsTableExport = memo(PreFillableFormsTable);

export { _PreFillableFormsTableExport as PreFillableFormsTable };
